
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-25f1504f&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./desCustomer.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./desCustomer.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-25f1504f!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./desCustomer.vue"),
  /* scopeId */
  "data-v-25f1504f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/orderManagement/desCustomer.vue
// module id = 1535
// module chunks = 3